
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import queryString from 'query-string';


const StripeReturn = (props) => {


    useEffect(() => {
    
        
        const queryStringParams = window.location.search;

        // Parse the query string using query-string library
        const queryParams = queryString.parse(queryStringParams);

        // Now you can access the query parameters as key-value pairs
        console.log('Query Parameters:', queryParams);
        var accountId = queryParams.acc;
        var companyId = queryParams.comp;

        axios.get('https://localhost:7294/payments/onboarding/complete/'+accountId+'/'+companyId)
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            console.log(error);
        });

    }, []);

    return (

        <div>
            Hello 
            <div className="home-links1">
                    <Link to="/" className="home-link navLink">
                       All done
                    </Link>
            </div>
        </div>
        

          
    ) 

}

export default StripeReturn
